import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxGym from '../../util/remote/ajaxGym';
import { useGym } from '../../DataStore/Gym/GymContext';

const AlertNewSession = ({ show, onClose, onConfirm }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [error, setError] = useState("");
  const [nextAction, setNextAction] = useState("search");
  const [actionName, setActionName] = useState("Search");
  const {storeCustomerPhoneNumber} = useGym();

  useEffect(() => {
    switch (nextAction) {
        case "start_session":
        setActionName("Start Session");
        break;
        case "end_session":
        setActionName("End Session");
        break;
        case "register":
        setActionName("Register");
        break;
        case "renew":
        setActionName("Renew");
        break;
        case "upgrade":
        setActionName("Upgrade");
        break;
        case "cancel":
        setActionName("Cancel");
        break;
        default:
        setActionName("Find Customer");
    }
  }, [nextAction]);

  const handleSearch = async () => {
    if (loading) { return; }
  
    setLoading(true);
    setError("");
    setCustomerInfo(null);
    storeCustomerPhoneNumber(phoneNumber);
    const server_response = await ajaxGym.fetchPhoneDetails(phoneNumber);
    setLoading(false);
    if (server_response.status === "OK") {
      setCustomerInfo(server_response.details);
      setNextAction(server_response.details.action_control);
    } else {
      setError("Customer not found. Please register them.");
      setNextAction('register');
    }
  };

  const handleForm = (e) => {
    e.preventDefault();
    handleContinue("search");
  }

  const handleContinue = (action) => {
    if (action === "search") {
      handleSearch();
      return;
    }
    switch (nextAction) {
      case "search":
        handleSearch();
        break;
        default:
         onConfirm(nextAction, customerInfo);
         cancel();
    }
  };

  const getBtnClass = (action)=>{
    switch (action){
        case "start_session":
            return "success";
        case "end_session":
            return "danger";
        case "register":
            return "info";
        default:
            return "primary";
    }
  }

  const cancel = () => {
    setPhoneNumber("");
    setCustomerInfo(null);
    setError("");
    setNextAction("search");
    onClose();
  }

  return (
    <BsModal
      show={show}
      onClose={cancel}
      title="New Gym Session"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={cancel}>
            Cancel
          </button>
          <button
            type="button"
            className={`btn btn-${getBtnClass(nextAction)}`}
            onClick={handleContinue}
            disabled={!phoneNumber || loading }
          >
            <i className="fa fa-check-circle mr-1"></i> {actionName}
          </button>
        </>
      }
    >
    <form method='post' onSubmit={handleForm}>

      {/* Phone Number Input */}
      <div className="form-group">
        <label htmlFor="phoneNumber" className="font-weight-bold">
          <i className="fa fa-phone mr-2 text-primary"></i> Customer Phone Number:
        </label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
            placeholder="Enter phone number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-primary"
              type="button"
              onClick={handleSearch}
              disabled={!phoneNumber || loading}
            >
              {loading ? <ActivityLoader inline={true} /> : <i className="fa fa-search"></i>}
            </button>
          </div>
         
        </div>
        <small className="text-muted">Phone number used to identify the customer.</small>
      </div>

      {/* Result */}
      {customerInfo && (
        <div className="alert alert-success">
          <strong>Customer Found:</strong> {customerInfo?.full_name} ({customerInfo?.membership_type.type_name})
        </div>
      )}
      {error && (
        <div className="alert alert-warning">
          <strong>Notice:</strong> {error}
        </div>
      )}
       </form>
    </BsModal>
  );
};

export default AlertNewSession;
